"use client";

import { type FC, type HTMLAttributes, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { isDocumentDefined } from "@huub-web/utils";

import type { RequiredChildrenProp } from "../../props";

export type PortalProps = HTMLAttributes<HTMLDivElement> &
  RequiredChildrenProp & {
    id?: string;
  };

/**
 * A portal component that renders its children in the #portal element.
 */
export const Portal: FC<PortalProps> = ({ children, id = "portal" }) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!isDocumentDefined()) {
      return;
    }

    const portalElement = document.getElementById(id);
    if (portalElement) {
      setElement(portalElement);
    } else {
      console.warn(`Portal element with ID ${id} not found`);
    }
  }, [id]);

  if (!element) {
    return null;
  }

  return createPortal(children, element);
};
